import { axios } from '@Root/API'

export const create = payload => {
	return axios.post('page-setting/rule', payload)
}
